import axiosInstance from './axiosConfig';

export type LayerKind = 'background' | 'text' | 'logo' | 'icon' | 'subject' | 'decoration' | 'object';

export type LayerSetStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface ImageLayer {
  id: number;
  z_index: number;
  kind: LayerKind;
  name: string;
  url: string;
  width: number | null;
  height: number | null;
  bbox: {
    x: number | null;
    y: number | null;
    width: number | null;
    height: number | null;
  };
  text_content: string | null;
  text_role: string | null;
  file_size: number | null;
}

export interface ImageLayerSet {
  id: number;
  generated_image_id: number;
  status: LayerSetStatus;
  engine: string;
  canvas_width: number | null;
  canvas_height: number | null;
  identity_psnr: number | null;
  credits_consumed: number;
  error_message: string | null;
  created_at: string;
  completed_at: string | null;
  layers?: ImageLayer[];
}

/** レイヤー分解を開始する。処理中のものがあればそれが返る */
export const startLayerDecomposition = async (imageId: number): Promise<ImageLayerSet> => {
  const res = await axiosInstance.post(`/images/${imageId}/layers`);
  return res.data.data;
};

/** 画像に紐づく最新のレイヤーセットを取得する（未分解なら null） */
export const fetchLayerSet = async (imageId: number): Promise<ImageLayerSet | null> => {
  const res = await axiosInstance.get(`/images/${imageId}/layers`);
  return res.data.data ?? null;
};

/** レイヤーセットを破棄する */
export const deleteLayerSet = async (layerSetId: number): Promise<void> => {
  await axiosInstance.delete(`/image-layer-sets/${layerSetId}`);
};
